import { useState } from 'react';
import { Pagination, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ThemedPagination = ({ count, page, onChange }) => {
  const theme = useTheme();
  const { customPagination } = theme.palette;
  const [pages, setPages] = useState(1);


  return (
    <Box display="flex" justifyContent="center">
      <Pagination
        count={count}
        page={pages}
        // onChange={(e, value) => {
        //   // console.log("e", e)
        //   console.log("value", value)
        //   setPages(value)
        //   // return value
        // }}
        onChange={(_, value) => {
          if (value === page || value === undefined)
            return;
          setPages(value)
          onChange(value)
        }}
        color="standard"
        showFirstButton={false}
        showLastButton={false}
        sx={{
          '& .MuiPaginationItem-root': {
            color: customPagination.inactiveText,
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: customPagination.main,
            color: customPagination.contrastText,
            '&:hover': {
              backgroundColor: customPagination.main,
            },
          },
        }}
      />
    </Box>
  );
};

export default ThemedPagination;
